import { Component, EventEmitter, OnInit, Output, Input, OnChanges } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import * as AgentAction from '../../../../redux/actions/loyalty/actions-agent';
import { Customer } from '@uxdf/direct-shared-lib';

@Component({
  standalone: false,
  selector: 'app-loyalty-login-form',
  templateUrl: './loyalty-login-form.component.html',
  styleUrls: ['./loyalty-login-form.component.scss']
})
export class LoyaltyLoginFormComponent implements OnInit, OnChanges {
  // @loyaltyDocs: loyalty-login-form component
  // Loyalty system login page. Has login and password fields

  @Input() customerConfig: Customer;
  @Output() viewLayout = new EventEmitter<string>();

  contactId: string;
  loginLoyaltyForm: UntypedFormGroup;

  // localize
  readonly loyaltyAmadeusPlusMeString = $localize`:@@loyalty-login-form.loyaltyAmadeusPlusMe:Amadeus+Me`;
  readonly credentials = $localize`:@@loyalty-login-form.credentials:credentials`;
  readonly loyaltyConnectAccountIWantNewOne = $localize`:@@loyalty-login-form.loyaltyConnectAccountIWantNewOne:Back`;
  readonly loyaltyConnectAccountThanksForBeignMemberString = $localize`:@@loyalty-login-form.loyaltyConnectAccountThanksForBeignMember:Thank you for being a loyal Amadeus+Me member.`;
  readonly loyaltyConnectAccountUseYourFirstCredentialsString = $localize`:@@loyalty-login-form.loyaltyConnectAccountUseYourFirstCredentials:Use your`;

  constructor(private readonly store: Store<any>) {
    this.loginLoyaltyForm = new UntypedFormGroup({
      number: new UntypedFormControl(null, [
        Validators.required,
        Validators.pattern('[0-9]*'),
        Validators.minLength(1),
        Validators.maxLength(20)
      ]),
      password: new UntypedFormControl(null, [Validators.required, Validators.minLength(1), Validators.maxLength(99)])
    });
  }

  goToEnrollForm(layout) {
    this.viewLayout.emit(layout);
  }

  bindAgent() {
    if (!this.loginLoyaltyForm.valid) {
      return;
    }
    const number = this.loginLoyaltyForm.get('number').value;
    const password = this.loginLoyaltyForm.get('password').value;

    this.store.dispatch(
      new AgentAction.BindAgent({
        number,
        password,
        contactId: this.contactId
      })
    );
  }

  ngOnInit() {
    window.scrollTo(0, 0);
  }

  ngOnChanges() {
    if (this.customerConfig) {
      this.contactId = this.customerConfig.contact_id;
    }
  }
}
